import {handleValidationChange} from '../CommonValidation';

export const validateCategory= (data, setIsError) => {

    var isValid = true;
    var isValidName = true;

    if(data.name === "") {
        handleValidationChange("name", true, setIsError);
        isValidName = false;
    } else {
        handleValidationChange("name", false, setIsError);
        isValidName = true;
    }


    isValid = isValidName 

    return isValid
  
}